import { HStack, Icon, Link } from '@chakra-ui/react'
import React from 'react'
import { FaLinkedin, FaGithub, FaInstagram, FaFacebook, FaGoogle } from "react-icons/fa";

function Social() {
  return (
   <HStack spacing="24">
        <Link href='https://www.linkedin.com/in/aakash-pandit-0a643812a/' isExternal>
            <Icon as={FaLinkedin} boxSize="50" />
        </Link>

        <Link href='https://github.com/Aakash-Pandit' isExternal>
            <Icon as={FaGithub} boxSize="50"/>
        </Link>

        <Link href='mailto:aakashpandit366@gmail.com' isExternal>
            <Icon as={FaGoogle} boxSize="50"/>
        </Link>

        <Link href='https://www.facebook.com/aakash.pandit.56/' isExternal>
            <Icon as={FaFacebook} boxSize="50"/>
        </Link>

        <Link href='https://www.instagram.com/iskypandit/' isExternal>
            <Icon as={FaInstagram} boxSize="50"/>
        </Link>
       
   </HStack>
  )
}

export default Social
